import { render, staticRenderFns } from "./AddAndAttachRoleDialog.vue?vue&type=template&id=202c4d22"
import script from "./AddAndAttachRoleDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAndAttachRoleDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports